const emptyAttributesInjector = () => {
	// do nothing
};

export default emptyAttributesInjector;
